import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import { getCourse } from '../common/api';
import { getCapitalName, getAllDepartments } from '../common/utils';

import SearchBar from '../components/SearchBar';
import InstructorSelector from '../components/InstructorSelector';
import CourseDetailWrapper from '../components/CourseDetailWrapper';

import '../styles/CoursePage.css';
import '../styles/SearchPage.css';


class CoursePage extends Component {
    constructor(props) {
        super(props);
        let selectedEidHash = null;
        if (props.location.query)
            selectedEidHash = props.location.query.selectedEidHash;
        else if (props.match.params.selectedEidHash)
            selectedEidHash = props.match.params.selectedEidHash;
        this.state = { courseId: parseInt(props.match.params.courseId), course: null, 
            selectedEidHash: selectedEidHash, selectedTerm: props.match.params.selectedTerm };
    }

    _loadCourseDetail() {
        getCourse(this.state.courseId).then((_course) => {
            if (_course) {
                let _selected = null;
                let instructors = this._getAllInstructors(_course);
                for (let instructor of instructors) {
                    if (instructor.eidHash === this.state.selectedEidHash) {
                        _selected = this.state.selectedEidHash;
                        break;
                    }
                }
                let selected = (!_selected) ? instructors[0].eidHash : this.state.selectedEidHash;
                this.setState({ course: _course, selectedEidHash: selected });
                this._setTitle(_course);
            }
        });
    }

    _setTitle(course) {
        const departments = getAllDepartments();
        let courseNumber = getCapitalName(departments[course.department].short_title) + ' ' + course.number;
        document.title = courseNumber + ' - Grade Distribution';
    }

    _getAllInstructors(course) {
        if (!course) course = this.state.course;
        if (!course) return;
        let instructors = [];
        Object.keys(course.instructors).forEach((_eidHash) => {
            let instructor = course.instructors[_eidHash];
            instructors.push({ name: instructor.name, eidHash: _eidHash, average: instructor.average,
                lastTerm: instructor.last_term });
        });
        // console.log(instructors);
        return instructors.sort((a, b) => b.lastTerm - a.lastTerm);
    }

    _getInstructor(eidHash) {
        if (eidHash && this.state.course)
            return this.state.course.instructors[eidHash];
    }

    _selectInstructor(eidHash) {
        if (eidHash) this.setState({ selectedEidHash: eidHash });
    }

    _getCourseName() {
        const departments = getAllDepartments();
        const course = this.state.course;
        let courseNumber = departments[course.department].short_title + ' ' + course.number;
        let courseDepartments = course.departments.map(deptNumber => departments[deptNumber].short_title).join(', ');
        let courseName = course.title;
        return (
            <div>
                <div id="course-number">{ courseNumber }</div>
                <div id="course-name">{ courseName }</div>
                <div id="course-departments">{ courseDepartments }</div>
            </div>
        ); // TODO: turn each department string in 'course-departments' into link to the department page
    }

    componentWillMount() {
        this._loadCourseDetail(this.state.courseId);
    }

    render() {
        const searchBar = (<div className="search-page-search-bar"><SearchBar /></div>);
        if ( !this.state.course ) {

            return (
                <div>
                    { searchBar }
                </div>
            );
        }
        // console.log(this._getInstructor(this.state.selectedEidHash));

        return (
            <div>
                { searchBar }
                <div className="course-page-header">
                    { this._getCourseName() }
                </div>
                <div className="course-page-instructor-selectoer">
                    <InstructorSelector getInstructors={ this._getAllInstructors.bind(this) }
                        selectInstructor={ this._selectInstructor.bind(this) } selected={ this.state.selectedEidHash } />
                </div>
                <div className="course-page-detail-container">
                    <CourseDetailWrapper instructor={ this._getInstructor(this.state.selectedEidHash) }
                        eidHash={ this.state.selectedEidHash } selectedTerm={ this.state.selectedTerm } />
                </div>
            </div>
        );
    }
}

export default CoursePage;



// WEBPACK FOOTER //
// ./src/containers/CoursePage.js